import { apiClient } from './apiClient';

const JSON_HEADERS = { headers: { 'Content-Type': 'application/json' } };

export async function listNotifications({ unread = false, limit = 50 } = {}) {
  const { data } = await apiClient.get('/api/notifications/', {
    params: { unread: unread ? 1 : 0, limit },
  });
  return data;
}

export async function markNotificationRead(id, read = true) {
  const { data } = await apiClient.patch(
    `/api/notifications/${id}/`,
    { read },
    JSON_HEADERS,
  );
  return data;
}

export async function markAllNotificationsRead() {
  const { data } = await apiClient.post('/api/notifications/mark-all-read/');
  return data;
}

// Aggregate unread-notification count for the caller. Drives the
// navbar bell-icon badge. Mirror of ``getUnreadMessagesCount`` —
// the bell previously read ``unread_count`` off a full
// ``listNotifications({limit:1})`` payload, which still serialized
// one row + envelope just to ship a number.
export async function getUnreadNotificationsCount() {
  const { data } = await apiClient.get('/api/notifications/unread-count/');
  return data?.unread_count ?? 0;
}

export async function deleteNotification(id) {
  const { data } = await apiClient.delete(`/api/notifications/${id}/`);
  return data;
}

// Per-user "do I want this kind of bell ping?" toggles. Backend
// keeps these on the User row (publication_alerts /
// collaboration_alerts / report_alerts); the dedicated endpoint
// avoids round-tripping the entire user payload via /findByEmail
// every time a single toggle flips, and gives us a single place to
// extend with future preference fields.
export async function getNotificationPreferences() {
  const { data } = await apiClient.get('/api/notifications/preferences/');
  return data?.preferences ?? {};
}

export async function updateNotificationPreferences(patch) {
  const { data } = await apiClient.patch(
    '/api/notifications/preferences/',
    patch,
    JSON_HEADERS,
  );
  return data?.preferences ?? {};
}
